export default {"src":"/_next/static/image/src/components/TooltipIcon/Question-Icon.6fc4f33d013448f180b47f97a8aba545.svg","height":24,"width":24};